// src/components/scratch/StateSelector.jsx
import React from "react";
import Icon from "../ui/Icon";

/**
 * Horizontal pill selector for the states that have an enabled data source.
 * @param {{
 *   states: import("../../services/scratchService").ScratchStateDto[],
 *   value: string,
 *   onChange: (code: string) => void,
 *   loading?: boolean
 * }} props
 */
export default function StateSelector({ states = [], value, onChange, loading = false }) {
  if (loading) {
    return (
      <div className="flex gap-2">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: 72,
              height: 34,
              borderRadius: 999,
              background: "var(--surf-2)",
              border: "1px solid var(--border)",
            }}
          />
        ))}
      </div>
    );
  }

  if (states.length === 0) {
    return (
      <p className="text-[13px] inline-flex items-center gap-2" style={{ color: "var(--txt-2)" }}>
        <Icon name="database" size={15} />
        No states are available yet.
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {states.map((s) => {
        const active = s.stateCode === value;
        return (
          <button
            key={s.stateCode}
            type="button"
            onClick={() => onChange(s.stateCode)}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-[13px] font-medium transition-all"
            style={{
              background: active ? "var(--gold-dim)" : "var(--surf-2)",
              border: `1px solid ${active ? "var(--gold-border)" : "var(--border)"}`,
              color: active ? "var(--gold-lt)" : "var(--txt)",
            }}
          >
            {s.stateCode}
            <span
              className="tabular-nums text-[11px]"
              style={{ color: active ? "var(--gold-lt)" : "var(--txt-3)" }}
            >
              {s.activeGameCount}
            </span>
          </button>
        );
      })}
    </div>
  );
}
